import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr, 'fr-FR');

console.log(
  `%c
  ████████╗██╗███╗   ███╗███████╗
  ╚══██╔══╝██║████╗ ████║██╔════╝
     ██║   ██║██╔████╔██║█████╗
     ██║   ██║██║╚██╔╝██║██╔══╝
     ██║   ██║██║ ╚═╝ ██║███████╗
     ╚═╝   ╚═╝╚═╝     ╚═╝╚══════╝
  ██████╗ ███████╗██████╗  ██████╗ ██████╗ ████████╗███████╗██████╗
  ██╔══██╗██╔════╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝██╔════╝██╔══██╗
  ██████╔╝█████╗  ██████╔╝██║   ██║██████╔╝   ██║   █████╗  ██████╔╝
  ██╔══██╗██╔══╝  ██╔═══╝ ██║   ██║██╔══██╗   ██║   ██╔══╝  ██╔══██╗
  ██║  ██║███████╗██║     ╚██████╔╝██║  ██║   ██║   ███████╗██║  ██║
  ╚═╝  ╚═╝╚══════╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═╝  ╚═╝
`,
  'color: #1976d2; font-weight: bold;'
);
console.log('%c⚡ Fait avec passion par l\'équipe MC UFOLEP41 ⚡', 'color: #ff9800; font-size: 14px; font-weight: bold;');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
